import * as THREE from 'three'
import { useContext, useEffect, useState } from 'react'
import { useThree } from '@react-three/fiber'
import { useAsset } from '../../c.managers/AssetsManager'
import { Audio, AudioListener } from 'three'
import { addEventListener, dispatch, EVENTS_SOUNDS } from '../../b.providers/EventsProvider/EventsProvider'
import { context as assetsContext } from '../../c.managers/AssetsManager/AssetsManager'
import TWEEN from '@tweenjs/tween.js'
import { Player } from '../../c.managers/LevelManager/store.d'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'

const audioRefs: Map<string, Audio> = new Map([])
type soundPlayConfigPayload = {
  soundName: string
  soundVolume: number
  soundLoop: boolean
}
export const API = {
  playMenuTheme: () => {
    const soundName = 'menuScore'
    // const soundName = 'menuScore'
    const notLoaded = !audioRefs.has(soundName)
    const loadedButNotPlaying = audioRefs.has(soundName) && !audioRefs.get(soundName)?.isPlaying
    if (notLoaded || loadedButNotPlaying) {
      dispatch(EVENTS_SOUNDS.PLAY, { soundName, soundVolume: 0.5, soundLoop: true })
    }
  },
  enterToBattle: () => {
    const soundName = 'battleScore'
    const soundNameToExit = 'menuScore'
    const notLoaded = !audioRefs.has(soundName)
    const loadedButNotPlaying = audioRefs.has(soundName) && !audioRefs.get(soundName)?.isPlaying
    if (notLoaded || loadedButNotPlaying) {
      dispatch(EVENTS_SOUNDS.FADEOUT, soundNameToExit)
      dispatch(EVENTS_SOUNDS.PLAY, { soundName, soundVolume: 0.5, soundLoop: true })
    }
  },
  finishBattle: (winner: CHARACTER_TYPES.JACK | CHARACTER_TYPES.WITCH) => {
    const soundName = 'howl'
    const winnerSoundName =
      winner === CHARACTER_TYPES.JACK ? 'jackLaugh' : winner === CHARACTER_TYPES.WITCH ? 'witchLaugh' : undefined
    const soundNameToExit = 'battleScore'
    // fade out battle music
    dispatch(EVENTS_SOUNDS.FADEOUT, soundNameToExit)
    // play howl
    dispatch(EVENTS_SOUNDS.PLAY, { soundName, soundVolume: 0.75, soundLoop: false })
    // delayed play laugh
    if(winnerSoundName) {
      setTimeout(() => {
        dispatch(EVENTS_SOUNDS.PLAY, { soundName: winnerSoundName, soundVolume: 0.5, soundLoop: false })
      }, 2500)
    }
  },
  playPunch: () => {
    const soundNames = [
      'punch1',
      'punch2',
      'punch3',
      'voicePunch1',
      'voicePunch2',
      'voicePunch3',
      'voicePunch4',
      'whoosh1',
    ]
    // totally random sound for hit
    const soundName = soundNames.at(Math.floor(Math.random() * soundNames.length - 1))!
    dispatch(EVENTS_SOUNDS.PLAY, { soundName, soundVolume: 0.5, soundLoop: false })
  },
  throwMagic: () => {
    // const soundName = 'magicThrown'
    const soundName = 'magicThrownAndHit'
    dispatch(EVENTS_SOUNDS.PLAY, { soundName, soundVolume: 1, soundLoop: false })
  },
}
const AudioController = () => {
  const [audioListener, setAudioListener] = useState<AudioListener>()
  const { camera } = useThree()
  const audios = useContext(assetsContext)

  useEffect(() => {
    if (camera) {
      const listener = new THREE.AudioListener()
      camera.add(listener)
      setAudioListener(listener)
    }
  }, [camera])

  useEffect(() => {
    let unsubPlay: any = undefined
    let unsubFadeOut: any = undefined
    if (audioListener) {
      // helper
      const getBufferFromSoundName = (soundName: string) => {
        const buffer = audios.assetsList[soundName] ?? null
        if(buffer === null) {
          throw new Error(`Missing sound asset in list: ${soundName}`)
        }
        return audios.assetsList[soundName] ?? null
      }

      // helper
      const getAudioFromSoundName = (soundName: string) => {
        let buffer = getBufferFromSoundName(soundName)

        if (!audioRefs.has(soundName) && buffer) {
          const sound = new THREE.Audio(audioListener)
          sound.setBuffer(buffer)
          audioRefs.set(soundName, sound)
        }

        return audioRefs.get(soundName)
      }

      // PLAY
      unsubPlay = addEventListener(EVENTS_SOUNDS.PLAY, event => {
        const { soundName, soundVolume, soundLoop } = event.payload as soundPlayConfigPayload
        const audio = getAudioFromSoundName(soundName)

        if (audio) {
          audio.setLoop(soundLoop)
          audio.setVolume(soundVolume)
          if (audio.isPlaying) {
            audio.stop()
          }
          audio.play()
        }
      })

      // FADE OUT
      unsubFadeOut = addEventListener(EVENTS_SOUNDS.FADEOUT, event => {
        const soundName = event.payload
        const audio = getAudioFromSoundName(soundName)

        if (audio && audio.isPlaying) {
          new TWEEN.Tween({ volume: 1 })
            .to({ volume: 0 }, 500)
            .onUpdate(partial => {
              audio.setVolume(partial.volume)
            })
            .onComplete(() => audio.stop())
            .start()
          // audio.setLoop(true)
          // audio.setVolume(0.5)
          // audio.play()
        }
      })
    }

    return () => {
      unsubPlay && unsubPlay()
      unsubFadeOut && unsubFadeOut()
    }
  }, [audioListener, audios])
  // useEffect(() => {
  //   if (audioSource && menuScore) {
  //     console.log('ready to play', menuScore)

  //     const buffer = menuScore

  //     // load a sound and set it as the Audio object's buffer
  //     // const audioLoader = new THREE.AudioLoader()
  //     // audioLoader.load(`${process.env.PUBLIC_URL}/assets/sfx/menu-score.mp3`, function (buffer) {
  //     audioSource.setBuffer(buffer)
  //     audioSource.setLoop(true)
  //     audioSource.setVolume(0.5)
  //     console.log(audioSource.play())

  //     // })
  //   }
  // }, [audioSource, menuScore])
  return null
}

export default AudioController
